exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#sidebar{position:relative !important;display:none}#page-container{position:relative !important}", ""]);

// exports
